
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom'
import store from './store/index'
import { Provider } from 'react-redux';


// 引入bootstrap
import 'bootstrap'
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
// 引入bootstrap的icon
import './assets/bootstrap-icons/font/bootstrap-icons.css'

import '@/assets/css/main.css'
// 国际化
import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import { nextLocal } from '@/common/nextLocal'; // 定义的语言文件
i18n
  .use(initReactI18next)
  .init({
    // 设置语言资源，可以根据需要引入其他语言文件
    resources: {
      en: {
        translation: {
          // 将所有需要国际化的文本放在这里
          // 例如："hello": "Hello",
          ...nextLocal.en
        },
      },
      cn: {
        translation: {
          // 中文翻译
          // 例如："hello": "你好",
          ...nextLocal.cn
        },
      },
    },
    lng: localStorage.getItem('Language') || 'en', // 默认语言
    fallbackLng: localStorage.getItem('Language') || 'en', // 如果当前语言没有对应的翻译，将使用该语言作为备用
    interpolation: {
      escapeValue: false, // 不要对翻译的文本进行转义，以支持 HTML 标签
    },
  })

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <Suspense>
        <App />
      </Suspense>
    </BrowserRouter>
  </Provider>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
